<vpfa-select
  [enabledSearch]="true"
  [options]="reducedOptions()"
  [parentFormGroup]="parentFormGroup"
  [fc]="fc"
  [translateLabel]="true"
  (scrollToBottom)="onScrollToBottom()"
  (onSearch)="onSearch($event)"
></vpfa-select>
